import { RequestHandler } from 'msw';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type MSWRequest = RequestHandler<any, any, any, any>;
